import { ActionsUnion, createAction } from "store/helper";

import { IAddCreditCardFailurePayload, IAddCreditCardRequestPayload } from "./interfaces";

export enum CreditCardActionNames {
  ADD_CREDIT_CARD_REQUEST = "CREDIT_CARD/ADD_CREDIT_CARD_REQUEST",
  ADD_CREDIT_CARD_SUCCESS = "CREDIT_CARD/ADD_CREDIT_CARD_SUCCESS",
  ADD_CREDIT_CARD_FAILURE = "CREDIT_CARD/ADD_CREDIT_CARD_FAILURE",
}

export enum CreditCardRequestFetchingSelectorsNames {
  ADD_CREDIT_CARD_REQUEST = "CREDIT_CARD/ADD_CREDIT_CARD",
}

export const CreditCardActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addCreditCard: (payload: IAddCreditCardRequestPayload) =>
    createAction(CreditCardActionNames.ADD_CREDIT_CARD_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addCreditCardSuccess: () => createAction(CreditCardActionNames.ADD_CREDIT_CARD_SUCCESS),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addCreditCardFailure: (payload: IAddCreditCardFailurePayload) =>
    createAction(CreditCardActionNames.ADD_CREDIT_CARD_FAILURE, payload),
};

export type CreditCardActionTypes = ActionsUnion<typeof CreditCardActions>;
